import React from "react";
import "../components/Style.css";
import { Link as RouterLink } from "react-router-dom";
import banner from '../assets/banner.jpg';
import CoreImg from '../assets/Trip.jpeg';

const OurCoreValuesPage = () => {
  return (
    <>
      {/* Breadcrumb Banner */}
      <section
        className="breadcrumb-banner"
        style={{ backgroundImage: `url("${banner}")` }}
      >
        <div className="breadcrumb-content">
          <h1 className="breadcrumb-title">Our Values</h1>
          <p className="breadcrumb-path">
            <RouterLink to="/" className="breadcrumb-link">Home</RouterLink>  / Our Values
          </p>
        </div>
      </section>

      {/* Main About Section */}
      <section className="about-us-container">
        <div className="about-us-content">
          {/* Image + Who We Are + Our Mission */}
          <div className="about-us-row">
            <div className="core-value-image">
              <img src={CoreImg} alt="Our Core Values" />
            </div>
            <div className="about-us-text">
              <h2>Our Core Values</h2>

              <h3>Our Mission</h3>
              <p>
                At TNG Global, our mission is to deliver excellence in a competitive travel industry by providing outstanding services and building on our reputation as a trusted travel partner for both domestic and international travelers, including our growing UK clientele.
              </p>
              <p>
                We place customers first every traveler is valued and privileged for choosing us. Our goal is to provide the best travel experiences and services, establishing TNG Global as a well-known and respected brand in the global travel industry.
              </p>
            </div>
          </div>

          {/* Goals & Achievements */}
          <div className="core-value-goals">
            <h3>Goals and Achievements of TNG Global</h3>
            <ul className="core-value-goals-list">
              <li>Offer customers a wider choice of destinations with competitive pricing.</li>
              <li>Promote diverse travel packages and experiences through online and offline channels.</li>
              <li>Invest in advanced software and technology to efficiently manage and grow the business.</li>
              <li>Cater to corporate and premium travelers, including First, Business, and Premium Economy classes.</li>
              <li>Provide solutions to all customer queries in a single window for a seamless experience.</li>
              <li>Deliver access to the world’s most fascinating destinations, finest hotels, and imaginative tours.</li>
              <li>Strive daily to become the first choice for travelers by offering cost-effective airline tickets and unbeatable deals across all airlines.</li>
            </ul>
          </div>
        </div>
      </section>
    </>
  );
};

export default OurCoreValuesPage;
